import React from 'react';

export default function EditPropertyModal({ show, onClose, form, onChange, onSave }) {
    if (!show) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
                <h2 className="text-xl font-semibold mb-4">Edit Property Details</h2>
                <form>
                    <div className="mb-4">
                        <p className="block font-bold uppercase text-gray-700 mb-1">Name</p>
                        <input
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={onChange}
                            className="w-full border border-gray-300 rounded px-3 py-2"
                        />
                    </div>
                    <div className="mb-4">
                        <p className="block font-bold uppercase text-gray-700 mb-1">Location</p>
                        <input
                            type="text"
                            name="location"
                            value={form.location}
                            onChange={onChange}
                            className="w-full border border-gray-300 rounded px-3 py-2"
                        />
                    </div>

                    <div className="mb-4">
                        <p className="block font-bold uppercase text-gray-700 mb-1">Property Description</p>
                        <input
                            type="text"
                            name="about"
                            value={form.about}
                            onChange={onChange}
                            className="w-full border border-gray-300 rounded px-3 py-2"
                        />
                    </div>
                    {/* <div className="mb-4">
                        <p className="block font-bold uppercase text-gray-700 mb-1">Property Type</p>
                        <input
                            type="text"
                            name="property_type"
                            value={form.property_type}
                            onChange={onChange}
                            className="w-full border border-gray-300 rounded px-3 py-2"
                        />
                    </div> */}
                    <div className="flex justify-end gap-2">
                        <button
                            type="button"
                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                            onClick={onSave}
                        >
                            Save
                        </button>
                    </div>
                </form>
                <button
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
                    onClick={onClose}
                >
                    &times;
                </button>
            </div>
        </div>
    );
}
